var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23.408,
    viewBox: "0 0 25 23.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(25 25.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c100_arrow",
    transform: "translate(0 2.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M0,14.088a2.619,2.619,0,0,0,2.477,2.736l14.071,0-3.8,4.206a3.05,3.05,0,0,0-.116,4,2.4,2.4,0,0,0,3.618-.13l7.944-8.785a3.044,3.044,0,0,0,.117-4c-.026-.026-.055-.045-.08-.071s-.056-.083-.091-.123L16.3,3.256a2.374,2.374,0,0,0-3.592-.1A3.028,3.028,0,0,0,12.8,7.13l3.817,4.219H2.477A2.615,2.615,0,0,0,0,14.088Z",
    transform: "translate(0 -2.384)",
    fill: "#fdfefe"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f14cf8a8c39bc99ea1a09ab7c7026516.svg";
export { ForwardRef as ReactComponent };